import { API_URL } from "@/constants/constants";
import axios from "axios";


export default class PresupuestosProvider {

  static async getPDF(uuid) {
    window.open(`${API_URL}/api/presupuesto/${uuid}/presupuesto.pdf`, "_blank")
  }

  static async getPresupuestos(fechaInicio, fechaFin) {
    let response = await axios.get(
      API_URL + "/api/presupuestos",
      {
        params: {
          fechaInicio,
          fechaFin
        }
      }
    );
    return response.data.data.presupuestos;
  }

    static async getPresupuestos_stats(fechaInicio, fechaFin) {
    let response = await axios.get(
      API_URL + "/api/presupuestos/stats",
      {
        params: {
          fechaInicio,
          fechaFin
        }
      }
    );
    return response.data.data.presupuestos;
  }

  static async newPresupuesto (presupuesto){
    const respuesta = await axios.post(
        API_URL + "/api/presupuesto",
        presupuesto
      );
      return respuesta.data.uuid
  }

  static async getPresupuesto (uuid){
    const respuesta = await axios.get(
      `${API_URL}/api/presupuesto/${uuid}`
      );
      return respuesta.data.data.presupuesto
  }

  static async deletePresupuesto (uuid){
    const respuesta = await axios.delete(
      `${API_URL}/api/presupuesto/${uuid}`
      );
      return respuesta.data.message
  }

  static async updatePresupuesto (presupuesto){
    const respuesta = await axios.patch(
      `${API_URL}/api/presupuesto/${presupuesto.uuid}`,
      presupuesto
      );
      return respuesta.data.uuid
  }
}
